module.exports = "<section *ngIf=\"products?.length\" class=\"container-fluid padding-top-2x\">\n  <h1 class=\"space-top-half text-uppercase text-center\">\n    {{ 'The Paragon Picks' | translate | async }}\n  </h1>\n  <div class=\"row padding-top\">\n    <div *ngFor=\"let product of products; let in=index\"\n         class=\"col-lg-3 col-md-4 col-sm-6\">\n      <product-summary [product]=\"product\"></product-summary>\n    </div>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/highlights.html
// module id = ./src/app/Templates/highlights.html
// module chunks = main